import { landmineNames } from '@mm/constants/landmine-names';
import React, { useEffect, useState } from 'react';

import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { GreenMarker } from '../../../../../common/components/GreenMarker/GreenMarker';
import { useGreenCueMarkers } from '../../../../../common/hooks/use-green-cue-markers';
import './ZapierPanel.scss';
import { ZapierIcon } from '@mm/icons';
import { BaseIntegration } from '../../../beta/modules/Integrations/BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../beta/modules/Integrations/BaseIntegration/BaseIntegrationHeader';
import { Help } from '../../../beta/modules/Integrations/NativeIntegrations/components/KlaviyoIntegrations/KlaviyoHelpLink';
import { ZapierApiKey } from './ZapierApiKey';

const ZAPIER_EMBED_PLACEHOLDER_ID = 'zapier-panel__zapier-embed-placeholder';
const ZAPIER_EMBED_SCRIPT_ID = 'zapier-panel__zapier-embed-script';
const ZAPIER_EMBED_URL =
  'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
const ZAPIER_EMBED_STYLESHEET_URL =
  'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';

const ZapierPanel = () => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const { isZapierActivated } = useGreenCueMarkers();

  // Add Zapier Embed to page
  useEffect(() => {
    if (isAccordionOpen) {
      const zapierEmbedScript = document.createElement('script');
      zapierEmbedScript.id = ZAPIER_EMBED_SCRIPT_ID;
      zapierEmbedScript.type = 'module';
      zapierEmbedScript.src = ZAPIER_EMBED_URL;
      document.head.appendChild(zapierEmbedScript);

      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = ZAPIER_EMBED_STYLESHEET_URL;
      document.head.appendChild(stylesheet);

      const element: any = document.createElement('zapier-zap-templates');
      element.theme = 'light';
      element.ids =
        '1559118,1563956,1563958,1563959,1563962,1563963,1563964,1563965,1563967,1563972';
      element.limit = 10;
      element.linkTarget = 'new-tab';
      element.presentation = 'row';
      element.useThisZap = 'show';
      const container = document.getElementById(ZAPIER_EMBED_PLACEHOLDER_ID);
      container?.appendChild(element);

      return () => {
        if (zapierEmbedScript && zapierEmbedScript.parentNode) {
          zapierEmbedScript.parentNode.removeChild(zapierEmbedScript);
        }
      };
    }
  }, [isAccordionOpen]);

  const sectionProps = {
    landmineName: landmineNames.INTEGRATIONS_ZAPIER,
    featureFlag: 'zapier',
  };

  const header = (
    <div className="zapier-panel--header-container">
      <PrimaryButton
        className="integrations__header-add-button-secondary"
        onClick={e => {
          e?.stopPropagation();
          window.open(
            'https://zapier.com/apps/mobilemonkey/integrations',
            '_blank',
          );
        }}
      >
        Сreate your own Zap template
      </PrimaryButton>
    </div>
  );

  return (
    <BaseIntegration
      titleComponent={
        <BaseIntegrationHeader
          title="Zapier"
          upgradeButtonName="Сreate your own Zap template"
          subtitle="Choose from our list of pre-built templates to integrate
           with other applications"
          icon={<ZapierIcon />}
          headerRightComponent={header}
          css={{ icon: 'integrations__zapier-header-icon' }}
          {...sectionProps}
        />
      }
      integrationType="zapier"
      onToggle={() => setIsAccordionOpen(!isAccordionOpen)}
    >
      <div className="zapier-panel__main-container">
        <div className="zapier-panel__details-container">
          <ZapierApiKey
            caption="You'll need this key to connect your Zapier account to
              MobileMonkey account"
          />
          {!isZapierActivated && (
            <GreenMarker className="zapier-panel__template-cue" />
          )}
          <div id={ZAPIER_EMBED_PLACEHOLDER_ID} />
        </div>
      </div>
    </BaseIntegration>
  );
};

export default ZapierPanel;
